import { PROJECTS_RECEIVED_GET_POWER_LOGGERS } from '../../legacy/actions/project-actions';
import PowerLoggerAssignment from '../../legacy/providers/types/redux-states/PowerLoggerAssignment';
import { legacyFulfill } from '../utils';
import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

interface PowerLoggerStasResponse {
  portal_account_id: number;
  id: number;
  name: string;
  power_loggers: PowerloggerCommunication[];
}

export interface PowerloggerCommunication {
  id: number;
  name: string;
  alias: null | null | string | string;
  last_communication: null | null | string | string;
}

export const powerLoggersApi = (builder: BuilderType) => ({
  getPowerLoggers: builder.query<any, void>({
    query: () => `service/power-loggers`,
    providesTags: [projectsCacheTags.POWER_LOGGERS],
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_GET_POWER_LOGGERS),
  }),

  getPowerLogger: builder.query<any, { id: number; isPortalAccountId?: boolean }>({
    query: ({ id, isPortalAccountId }) =>
      `service/power-loggers/${id}?is_portal_account_id=${isPortalAccountId}`,
    providesTags: (result, error, powerLoggerId) => [
      { type: projectsCacheTags.POWER_LOGGERS, id: powerLoggerId },
    ],
  }),
  getPowerLoggerAssignments: builder.query<
    { id: number; isPortalAccountId?: boolean },
    PowerLoggerAssignment[]
  >({
    query: ({ id, isPortalAccountId }) =>
      `service/power-loggers/${id}/assignments?is_portal_account_id=${isPortalAccountId}`,
    providesTags: (result, error, powerLoggerId) => [
      { type: projectsCacheTags.POWER_LOGGERS, id: powerLoggerId },
    ],
  }),

  getPowerLoggerCurrentAssignments: builder.query<PowerLoggerAssignment[], void>({
    query: () => `service/power-loggers/current-assignments`,
  }),

  assignPowerLogger: builder.mutation<any, Partial<Assignment>>({
    query: (assignment) => ({
      url: `service/power-loggers/${assignment.power_logger_id}/assign`,
      method: 'POST',
      body: assignment,
    }),
    invalidatesTags: [projectsCacheTags.POWER_LOGGERS],
  }),

  updatePowerLoggerAssignment: builder.mutation<any, Partial<Assignment>>({
    query: (assignment) => ({
      url: `service/power-loggers/${assignment.power_logger_id}/assign/${assignment.id}`,
      method: 'PUT',
      body: assignment,
    }),
    invalidatesTags: [projectsCacheTags.POWER_LOGGERS],
  }),

  // prettier-ignore
  deletePowerLoggerAssignment: builder.mutation<any,{ id: number; powerLoggerId: number }>({
    query: ({ id, powerLoggerId }) => ({
      url: `service/power-loggers/${powerLoggerId}/assign/${id}`,
      method: "DELETE",
    }),
    invalidatesTags: [projectsCacheTags.POWER_LOGGERS],
  }),

  // prettier-ignore
  getLoggerMostRecent: builder.query<any,{ id: number; timeZoneOffset: string }>({
    query: ({ id, timeZoneOffset }) =>
      `service/power-loggers/${id}/most-recent/${timeZoneOffset}`,
    providesTags: [projectsCacheTags.POWER_LOGGERS],
  }),

  getPowerLoggerStats: builder.query<PowerLoggerStasResponse[], any>({
    query: () => `service/power-loggers/stats`,
  }),
  getPowerLoggerCurrentAssignment: builder.query<any, { id: number; isPortalAccountId?: boolean }>({
    query: ({ id, isPortalAccountId }) =>
      `service/power-loggers/${id}/current-assignment?is_portal_account_id=${isPortalAccountId}`,
  }),
});
